import { __assign } from "tslib";
import React from 'react';
import { useEnabledFlagList } from './hooks/useEnabledFlagList';
export default function withFeatureFlags(Component) {
    var Decorated = function (props) {
        var flags = useEnabledFlagList();
        return React.createElement(Component, __assign({ flags: flags }, props));
    };
    Decorated.displayName = "withFeatureFlags(".concat(Component.displayName || 'Component', ")");
    return Decorated;
}
//# sourceMappingURL=withFeatureFlags.js.map